import script from "./PosHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PosHeader.vue?vue&type=script&setup=true&lang=js"

import "./PosHeader.vue?vue&type=style&index=0&id=5f54d18e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f54d18e"]])

export default __exports__